import { useReleaseExclusiveHold } from '~/api/mutations/exclusives/useReleaseExclusiveHold';
import { prePopulationFromHold, type ExclusiveHoldRow } from '~/utils/exclusives/holdRows';

export const DEAL_REGISTER_ROUTE = '/deals/register';

// "Continue to deal" and "Release hold" for a held unit (ID-119), shared by the project page and /deals.
export const useExclusiveHoldActions = () => {
  const dealRegistrationStore = useDealRegistrationStore();
  const { sendEventToBackend } = useTracking();
  const releaseMutation = useReleaseExclusiveHold();

  const continueToDeal = async (row: ExclusiveHoldRow) => {
    dealRegistrationStore.setPrePopulation(prePopulationFromHold(row));
    void sendEventToBackend('exclusive_hold_continue_to_deal', {
      holdId: row.holdId,
      catalogueProjectId: row.catalogueProjectId,
    });
    await navigateTo(DEAL_REGISTER_ROUTE);
  };

  const releaseHold = (holdId: string) => releaseMutation.mutateAsync(holdId);

  return {
    continueToDeal,
    releaseHold,
    isReleasing: releaseMutation.isPending,
  };
};
